// SWA-139 · Fuente única para presentar métricas de retorno.
// Envuelve a formatPercent, no lo sustituye. La guarda de sentinels
// del propio formatPercent se corrige aparte en SWA-161.
import { formatPercent, formatNumber } from './utils';

function isSentinel(v) {
  if (v === null || v === undefined) return true;
  if (typeof v !== 'number' || Number.isNaN(v)) return true;
  if (v <= -100) return true;
  if (v >= 999) return true;
  return v === -1;
}

function moicDisplay(moic) {
  return moic != null ? `${formatNumber(moic, 2)}x` : 'N/A';
}

export function getReturnMetric(metrics) {
  const m = metrics || {};
  const irr = m.irr_annual;
  const mirr = m.mirr;
  const moic = m.moic ?? null;

  // Disponibilidad de MIRR: independiente de is_irr_reliable.
  // La bandera califica a la TIR, no a la MIRR.
  const mirrUsable = !isSentinel(mirr);
  const mirrValue = mirrUsable ? mirr : null;

  // Falla cerrada: bandera ausente, null o undefined = NO confiable.
  const reliable = m.is_irr_reliable === true && !isSentinel(irr);

  const common = {
    mirrUsable,
    mirrValue,
    moic,
    moicDisplay: moicDisplay(moic),
    rawIrr: isSentinel(irr) ? null : irr,
  };

  if (reliable) {
    return {
      ...common,
      reliable: true,
      label: 'TIR Anual',
      key: 'irr_annual',
      value: irr,
      display: formatPercent(irr),
      note: m.irr_note || null,
    };
  }

  return {
    ...common,
    reliable: false,
    label: mirrUsable ? 'MIRR' : 'MOIC',
    key: mirrUsable ? 'mirr' : 'moic',
    value: mirrUsable ? mirr : moic,
    display: mirrUsable ? formatPercent(mirr) : moicDisplay(moic),
    note: m.irr_note || 'TIR no interpretable en esta corrida.',
  };
}


// SWA-134 · mejor retorno del INVERSIONISTA entre escenarios. Solo compara métricas
// iguales: TIR confiable > MIRR > MOIC. Devuelve el getReturnMetric ganador o null.
export function bestReturnMetric(metricsList) {
  const rms = (metricsList || []).map(m => getReturnMetric(m)).filter(r => r && r.value != null);
  for (const key of ['irr_annual', 'mirr', 'moic']) {
    const same = rms.filter(r => r.key === key);
    if (same.length) return same.reduce((a, b) => (b.value > a.value ? b : a));
  }
  return null;
}
